import qs from 'qs';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import { useLocation } from 'react-router-dom';

import { DEFAULT_LIMIT, MAX_RETRY_TIMEOUT, MIN_RETRY_TIMEOUT } from 'src/constants';
import { useQueryEntities } from 'src/hooks/useQueryEntities';
import { isSearchPopulated } from 'src/utils';

type PagedEntities = Models.V3.PageResult<Models.ContentStoreApi.V3.Entity>;

export const useQueryEntitiesPage = (
    accessToken: string | undefined | false,
    search: App.Entities.Search,
    options?: UseQueryOptions<PagedEntities, Error, PagedEntities, App.Entities.PagedQueryKey>,
): UseQueryResult<PagedEntities, Error> & { page: number } => {
    const location = useLocation();
    const { page: pageParam } = qs.parse(location.search.slice(1));
    const page = pageParam ? parseInt(pageParam.toString(), 10) : 1;

    const result = useQueryEntities(
        accessToken,
        {
            ...search,
            offset: (page - 1) * DEFAULT_LIMIT,
            limit: DEFAULT_LIMIT,
        },
        {
            enabled: !!accessToken && isSearchPopulated(search),
            retry: 3,
            retryDelay: (attempt) => Math.min(attempt > 1 ? 2 ** attempt * 1000 : MIN_RETRY_TIMEOUT, MAX_RETRY_TIMEOUT),
            staleTime: 750,
            ...options,
        },
        false,
    );

    return { ...result, page };
};
